import { post, del, get } from './generic.api';

export const fetchCategories = async (clientId) => {
    const response = await get(`/category/?client=${clientId}`);
    return response.results;
  };